import React from "react";
import Menu from "./Menu";
import { BrowserRouter as Router } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import CambiarFoto from "../comun/CambiarFoto.jsx";
import Proyecto from "../comun/Proyecto.jsx";
import Actividades from "./Actividades.jsx";
import Foro from "../comun/Foro.jsx";
import Chat from "../comun/Chat.jsx";
import Sala from "../comun/SalaVideo.jsx";
import NotFound from "../comun/NotFound.jsx";

const index = (props) => {
  return (
    <Router>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-3">
            <Menu
              Id={props.perfil.Id}
              Nbres={props.perfil.Nbres}
              Proyecto={props.perfil.NbreProyecto}
              Foto={props.perfil.Foto}
              Socket={props.socket}
              Auditor={props.perfil.Auditor}
              cerrarSesion={props.cerrarSesion}
            />
          </div>
          <div className="col-sm-9">
            <Routes>
              <Route
                path="/foto"
                element={
                  <CambiarFoto
                    Ruta={"fotos"}
                    Tabla={"usuarios"}
                    Campo={"Foto"}
                    Id={props.perfil.Id}
                    Foto={props.perfil.Foto}
                    actualizarCampoPerfil={props.actualizarCampoPerfil}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route
                path="/proyecto"
                element={<Proyecto perfil={props.perfil} />}
              />
              <Route
                path="/actividad"
                element={
                  <Actividades
                    idUsuario={props.perfil.Id}
                    idProyecto={props.perfil.IdProyecto}
                    tipoParticipante={props.perfil.TipoParticipante}
                    mostrarMsg={props.mostrarMsg}
                    correoDirector={props.perfil.CorreoDirector}
                    nbres={props.perfil.Nbres + " " + props.perfil.Apellidos}
                    llamador={"beneficiario"}
                  />
                }
              />
              <Route
                path="/chat"
                element={
                  <Chat
                    idUsuario={props.perfil.Id}
                    nbreUsuario={props.perfil.Nbres}
                    tipoParticipante={props.perfil.TipoParticipante}
                    idProyecto={props.perfil.IdProyecto}
                    nbreProyecto={props.perfil.NbreProyecto}
                    socket={props.socket}
                  />
                }
              />
              <Route
                path="/foro"
                element={
                  <Foro
                    idUsuario={props.perfil.Id}
                    idProyecto={props.perfil.IdProyecto}
                    tipoParticipante={props.perfil.TipoParticipante}
                    mostrarMsg={props.mostrarMsg}
                  />
                }
              />
              <Route
                path="/sala"
                element={
                  <Sala
                    idUsuario={props.perfil.Id}
                    idProyecto={props.perfil.IdProyecto}
                    nbres={props.perfil.Nbres}
                    tipoUsuario={props.perfil.TipoUsuario}
                    socket={props.socket}
                  />
                }
              />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
};

export default index;
